import React from 'react';

import Header from '../../components/header/header.component';
import Profile from '../visit-profile/visit-profile.component';
import Footer from '../../components/footer/footer.component';

const VisitDocuments = (props) => (
  <div className='parent'>
    <Header />

    <Profile {...props} />

    <Footer />
  </div>
);

export default VisitDocuments;
